export const BUILD_INFO = {
  buildId: '181287',
  commit: '832b82b'
};
